<template>
  <div>
    <h1> {{ $t('userManager.actions.managePermissions') }} </h1>
    <UmisisDataTableIntegrated :fields="fields" :use-store="userPermissionStore">
      <template #cell(actions)="{ row }">
        <div class="flex flex-col gap-2 sm:flex-row">
          <Button @click="console.log('Edit user', row.id)">
            {{ $t('userManager.actions.editPermission') }}
          </Button>
          <UmisisDeleteItemButton :delete-by-value="row.id" :use-store="userPermissionStore" @deleted="deletedPermission" />
        </div>
      </template>
    </UmisisDataTableIntegrated>
  </div>
</template>

<script setup>
// This component is intentionally simple.
// You can add any shared logic for your package's routes here.
import UmisisDeleteItemButton from '../../../../../../resources/js/components/umisis/generic/UmisisDeleteItemButton.vue'
import UmisisDataTableIntegrated from '../../../../../../resources/js/components/umisis/generic/UmisisDataTableIntegrated.vue'
import { Button } from '../../../../../../resources/js/components/ui/button/index.js'
import { useI18n } from 'vue-i18n'
import { useUserPermissionStore } from '../stores/userPermissionStore.js'
import { toast } from 'vue-sonner'
const { t } = useI18n()

let userPermissionStore = useUserPermissionStore()

const fields = [
  { name: 'id', label: 'ID', sortable: true },
  { name: 'name', label: 'Name', sortable: true },
  { name: 'email', label: 'Email', sortable: true },
  { name: 'created_at', label: 'Created At', sortable: true, formatter: (value) => new Date(value).toLocaleDateString() },
  { name: 'actions', label: 'Actions' },
]

const deletedPermission = (data) => {
  console.log('Permission deleted:', data)
  // Optionally refresh the user list or show a notification
  userPermissionStore.fetchItems()
  // send the notification
  toast(t('userManager.notifications.permissionDeleted'), {
    type: 'success',
  })
}

</script>
